export default __webpack_public_path__ + "f63044f7ce23e73547297d676c918dae.png";